import { FaUsers } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../../../context/AuthProvider";
import TippersTab from "./TippersTab";
import UsersTab from "./UsersTab";

type Tab = "tippers" | "users";

type Props = {
  defaultTab?: Tab;
};

const CommunityPage = ({ defaultTab = "tippers" }: Props) => {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const fromUrl = params.get("tab");
  const tab: Tab =
    fromUrl === "tippers" || fromUrl === "users" ? fromUrl : defaultTab;

  const tabButton = (value: Tab, label: string) => (
    <button
      role="tab"
      aria-selected={tab === value}
      className={`tab ${tab === value ? "tab-active" : ""}`}
      onClick={() => setParams({ tab: value }, { replace: true })}
    >
      {label}
    </button>
  );

  // Both tabs stay mounted and are only hidden, so each keeps its search,
  // filters and scroll position while you look at the other one.
  return (
    <div className="bg-base-200 h-full flex flex-col p-2 sm:p-4 gap-3 min-h-0">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-xl font-bold flex items-center gap-2">
          <FaUsers className="text-primary" />
          {user?.username ? `${user.username}'s Community` : "Community"}
        </h2>
        <div role="tablist" className="tabs tabs-boxed">
          {tabButton("tippers", "CB Tippers")}
          {tabButton("users", "Reinstorm Users")}
        </div>
      </div>
      <div
        className={tab === "tippers" ? "flex-1 min-h-0 flex flex-col" : "hidden"}
      >
        <TippersTab />
      </div>
      <div
        className={tab === "users" ? "flex-1 min-h-0 flex flex-col" : "hidden"}
      >
        <UsersTab />
      </div>
    </div>
  );
};

export default CommunityPage;
